import type { RouteMode } from "../../router";
import { isPlatformGamePath } from "../../shared/routing/game-path-mode";
import type { GameApiMode } from "../../shared/services/game-api";

function currentPathname(): string {
  return typeof window === "undefined" ? "" : window.location.pathname;
}

export function isAlkagiV2Path(pathname = currentPathname()): boolean {
  return isPlatformGamePath("alkagi", pathname);
}

export function resolveAlkagiRouteMode(
  pathname = currentPathname(),
): RouteMode {
  return isAlkagiV2Path(pathname) ? "v2" : "legacy";
}

export function resolveAlkagiGameApiMode(
  pathname = currentPathname(),
): GameApiMode {
  return isAlkagiV2Path(pathname) ? "game-platform" : "legacy";
}
